export default {
  why: {
    heroTitlePre: 'Infoware S. A.:',
    heroTitleExpert: 'Expertos',
    heroTitleMid: 'en organizar tus',
    heroTitleHighlight: 'procesos y tecnologías',
    heroSubtitle: 'Nos convertimos en un socio estratégico para nuestros clientes.',
    missionTitle: 'Misión',
    missionText: 'Ayudar a las organizaciones latinoamericanas a mejorar sus procesos administrativos mediante el uso efectivo de la tecnología de información.',
    visionTitle: 'Visión',
    visionText: 'Ser una plataforma tecnológica colaborativa que permita a las organizaciones mejorar sus procesos y hacerlos más efectivos incorporando recursos humanos y empresas especializadas como agentes.',
    cred1Value: '20+',
    cred1Text: 'Años innovando en Latinoamérica',
    cred2Value: 'Carbon Neutral',
    cred2Text: 'Certificado Carbono Neutral',
    cred3Value: 'ISO 27001',
    cred3Text: 'Certificado con ISO 27001',
    expertiseTitle: 'Nuestra experiencia tecnológica',
    card1H4a: 'Diseño de interfaces',
    card1Pa: 'Diseño de interfaces para casi todas las aplicaciones.',
    card1H4b: 'Desarrollo de ecosistemas digitales',
    card1Pb: 'Para optimizar la interoperabilidad de aplicaciones.',
    card2H4a: 'Desarrollo de integraciones',
    card2Pa: 'Con equipos de IBM, UNISYS, ORACLE y SyBase.',
    card2H4b: 'Combinación de tecnologías y técnicas',
    card2Pb: 'HTML, PHP, XML, XSLT, JavaScript, AJAX, .NET, NodeJS, C++.',
    card3H4a: 'Infraestructura tecnológica',
    card3Pa: 'Para redes de distribución de productos electrónicos.',
    card3H4b: 'Internet Banking y Software',
    card3Pb: 'B2B, B2P, P2P.',
    card4H4a: 'Robotización, emulación e intermediación',
    card4Pa: 'Entre tecnologías.',
    card4H4b: 'Migraciones, optimización, integración y resolución',
    card4Pb: 'De múltiples aplicaciones y problemas.',
    clientsTitle: 'Encuéntranos en',
    clientsSubtitle: 'Costa Rica, El Salvador, Colombia y Perú',
    clientsDesc: 'Gobiernos, instituciones financieras, industrias y servicios.',
    dotLabel: 'Ir a la diapositiva',
    supportImageAlt: 'Centro de soporte y mejora continua de Infoware S. A.',
    supportTitlePre: 'Centro de soporte',
    supportTitlePost: 'y mejora continua',
    supportPriority: 'Nuestra prioridad es escucharte.',
    supportIntro: 'En nuestro portal podrás:',
    supportItem0: 'Enviar tickets sobre problemas o inconvenientes que encuentres.',
    supportItem1: 'Dar seguimiento a los tickets que has enviado.',
    supportItem2: 'Revisar tickets enviados por tu institución.',
    supportItem3: 'Aprender de nuestra base de conocimiento.',
    supportItem4: 'Acceder a nuestra comunidad de clientes.',
    supportItem5: 'Encontrar y compartir soluciones a través de nuestro foro.',
    supportButton: '¡Ir al centro de soporte!',
    saasTitle: 'Servicio SaaS',
    saasIntroPre: 'Dile',
    saasIntroHighlight: 'adiós',
    saasIntroPost: 'a los problemas de hardware, licenciamiento y administración de aplicaciones.',
    saasGrid0: 'Plataforma de hardware y software dirigida a clientes que requieren una solución integral para su trabajo de gestión, proporcionando un sitio seguro con los recursos de software y hardware apropiados.',
    saasGrid1: 'Plataforma de 3 servidores en cluster cada uno con 3 teras en md-RAD1, 64GB RAM y 6 procesadores de 3.2MHz.',
    saasGrid2: 'Arquitectura de servidores que garantiza confiabilidad, balanceo de carga y seguridad tipo Internet Banking.',
    availabilityTitlePre: 'Disponibilidad sobre',
    availabilityHighlight: '99%',
    availabilityTitlePost: 'del tiempo',
    availabilityTextPre: 'Para proteger su valiosa información, Infoware S. A. es responsable de la administración de servidores y bases de datos, pero no tiene conocimiento de las credenciales de los usuarios para acceder a la aplicación. La administración de',
    availabilityTextHighlight: 'seguridad',
    availabilityTextPost: 'es tarea del administrador designado por el cliente.',
    availCard0: 'Foro de soporte y mejora continua.',
    availCard1: 'Aplicación de actualizaciones de GPAX.',
    availCard2: 'Chat de soporte en línea.',
    availCard3: 'Réplicas en diferentes países.',
    ctaTitle: '¿Quieres saber más sobre nosotros?',
    ctaButton: 'Contáctanos',
  },
};